import {createSvgIcon} from "@buildwitt/shapeshift-common/v1/icon";

export const IconFolder = createSvgIcon(
	<svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M8.75 0H2.75C1.65 0 0.76 0.9 0.76 2L0.75 14C0.75 15.1 1.65 16 2.75 16H18.75C19.85 16 20.75 15.1 20.75 14V4C20.75 2.9 19.85 2 18.75 2H10.75L8.75 0Z" fill="white"/>
	</svg>,
	"Folder",
	"0 0 21 16"
);